// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__aYbWS","bigColWidth":"Table_bigColWidth__Mq1PD","biggerColWidth":"Table_biggerColWidth__1JGcn","row":"Table_row__2C4hW","col":"Table_col__3yLNx"};